import Facebook from "assets/images/icon/svg/Facebook";
import Insta from "assets/images/icon/svg/Insta";
import Linkdin from "assets/images/icon/svg/Linkdin";
import Twitter from "assets/images/icon/svg/Twitter";
import Youtube from "assets/images/icon/svg/Youtube";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function Footer() {
	const ekkLanguage = useSelector((state) => state.lan.lan);
	return (
		<section className='md:pt-[10px] sm:pt-[10px] lg:pt-[0] pt-[20px]'>
			<div className='container mx-auto bg-F2F3F7'>
				<div className='flex flex-wrap pt-10 pb-7'>
					<div className='xl:w-3/12 lg:w-6/12 md:w-6/12 sm:w-full pr-10'>
						<img
							className='w-[100px] mt-12 mb-4'
							src='/assets/images/LogoAI.png'
							alt='logo'
						/>
						{/* <p className='text-16 text-808080 font-normal mb-7'>
							{ekkLanguage.landing.fAbout}
						</p> */}
						{/* <div className='flex'>
							<a
								href='https://www.facebook.com/EkkBazBangladesh'
								target='_blank'
								rel='noreferrer'
								className='pr-5'>
								<Facebook />
							</a>
							<a
								href='https://www.linkedin.com/company/7603237/admin/'
								target='_blank'
								rel='noreferrer'
								className='pr-5'>
								<Linkdin />
							</a>
							<a
								href='https://www.youtube.com/c/EkkBaz'
								target='_blank'
								rel='noreferrer'
								className='pr-5'>
								<Youtube />
							</a>
							<a
								href='https://www.instagram.com/ekkbaz/'
								target='_blank'
								rel='noreferrer'
								className='pr-5'>
								<Insta />
							</a>
							<a
								href='https://twitter.com/EkkBaz'
								target='_blank'
								rel='noreferrer'
								className='pr-5'>
								<Twitter />
							</a>
						</div> */}
						<div className='flex items-center '>
							<a
								href='https://www.facebook.com/EkkBazBangladesh'
								target='_blank'
								className='zoom-image transform transition-transform hover:scale-110 mr-4'
								rel='noreferrer'>
								<img
									className='w-[30px] h-[30px]'
									src='/assets/images/facebook_new.png'
									alt=''
								/>
								{/* <Facebook /> */}
							</a>
							<a
								href='https://twitter.com/EkkBaz'
								target='_blank'
								className='zoom-image transform transition-transform hover:scale-110 mr-4'
								rel='noreferrer'>
								<img
									className='w-[30px] h-[30px]'
									src='/assets/images/twitter_new.png'
									alt=''
								/>
								{/* <Twitter /> */}
							</a>
							<a
								href='https://www.linkedin.com/company/7603237/admin/'
								target='_blank'
								className='zoom-image transform transition-transform hover:scale-110 mr-4'
								rel='noreferrer'>
								<img
									className='w-[30px] h-[30px]'
									src='/assets/images/linkedin_new.png'
									alt=''
								/>
								{/* <Linkdin /> */}
							</a>
							<a
								href='https://www.instagram.com/ekkbaz/'
								target='_blank'
								className='zoom-image transform transition-transform hover:scale-110 mr-4'
								rel='noreferrer'>
								<img
									className='w-[30px] h-[30px]'
									src='/assets/images/instagram_new.png'
									alt=''
								/>
								{/* <Insta /> */}
							</a>
							<a
								href='https://www.youtube.com/c/EkkBaz'
								target='_blank'
								className='zoom-image transform transition-transform hover:scale-110'
								rel='noreferrer'>
								<img
									className='w-[30px] h-[30px]'
									src='/assets/images/youtube_new.png'
									alt=''
								/>
								{/* <Youtube /> */}
							</a>
						</div>
					</div>
					<div className='xl:w-2/12 lg:w-3/12 md:w-3/12 sm:w-1/2 w-1/2 pt-7'>
						<h4 className='text-18 sm:text-20 font-bold text-return mb-4'>
							{ekkLanguage.landing.location}
						</h4>
						<h6 className='text-14 sm:text-16 font-bold text-808080 mb-2'>
							USA Office
						</h6>
						<p className='text-12 sm:text-16 font-normal text-808080'>
							Block 71, 107 S B St #300, San Mateo, California 94401, USA
						</p>
					</div>
					<div className='xl:w-2/12 lg:w-3/12 md:w-3/12 sm:w-1/2 w-1/2 pt-7'>
						<h6 className='text-14 sm:text-16 font-bold text-808080 mb-2 pt-10'>
							{ekkLanguage.landing.singapore}
						</h6>
						<p className='text-12 sm:text-16 font-normal text-808080'>
							60 Paya Lebar Road, #06-28 Paya Lebar Square, Singapore
							409051
						</p>
					</div>
					<div className='xl:w-2/12 lg:w-3/12 md:w-3/12 sm:w-1/2 w-1/2 pt-7'>
						<h6 className='text-14 sm:text-16 font-bold text-808080 mb-2 pt-10'>
							{ekkLanguage.landing.bangladesh}
						</h6>
						<p className='text-12 sm:text-16 font-normal text-808080'>
							{ekkLanguage.landing.bOfficeAddress}
						</p>
					</div>

					{/* <div className='xl:w-2/12 lg:w-6/12 md:w-6/12 sm:w-1/2 w-1/2 pt-7'>
						<h4 className='text-18 sm:text-20 font-bold text-return mb-4'>
							{ekkLanguage.landing.otherInfo}
						</h4>
						<Link
							to='/post/en'
							className='block pb-[10px] text-12 sm:text-16 font-normal text-delivered '>
							{ekkLanguage.landing.blog}
						</Link>
						<Link
							to='/terms-conditions'
							className='block pb-[10px] text-12 sm:text-16 font-normal text-delivered'>
							{ekkLanguage.landing.termsCondition}
						</Link>
						<Link
							to='/privacy-policy'
							className='block pb-[10px] text-12 sm:text-16 font-normal text-delivered'>
							{ekkLanguage.landing.privacyPolicy}
						</Link>
						<Link
							to='/refund-policy'
							className='block pb-[10px] text-12 sm:text-16 font-normal text-delivered'>
							{ekkLanguage.landing.refundPolicy}
						</Link>
					</div> */}
					<div className='xl:w-3/12  lg:w-6/12 md:w-6/12 sm:w-1/2 w-1/2 pt-7'>
						<h4 className='text-18 sm:text-20 font-bold text-return mb-4'>
							{ekkLanguage.landing.contactUs}
						</h4>
						<span className='block pb-[10px] text-12 sm:text-16 font-normal text-808080'>
							{ekkLanguage.landing.messageUs}:{" "}
							<a
								href='https://www.facebook.com/EkkBazBangladesh'
								target='_blank'
								rel='noreferrer'
								className='text-delivered'>
								{ekkLanguage.landing.facebook}
							</a>
						</span>
						<span className='block pb-[10px] text-12 sm:text-16 font-normal text-808080'>
							{ekkLanguage.landing.sales}:{" "}
							<a
								href='mailto:Sales@ekkbaz.ai'
								className='text-delivered'>
								Sales@ekkbaz.ai
							</a>
						</span>
						<span className='block pb-[10px] text-12 sm:text-16 font-normal text-808080'>
							{ekkLanguage.landing.support}:{" "}
							<a href='mailto:Help@ekkbaz.ai' className='text-delivered'>
								Help@ekkbaz.ai{" "}
							</a>
						</span>
					</div>
				</div>
				<hr className='border-delivered border-2 border-top rounded-[100%] w-[85%] m-auto' />
				<div>
					<p className='text-12 font-normal text-808080 pt-4 pb-4 text-center'>
						Copyright @ <b>Enam Pte. Ltd.</b> All Rights Reserved.
					</p>
				</div>
			</div>
		</section>
	);
}
